module.exports = __webpack_public_path__ + "static/media/image11.c663ea26.png";